import React from 'react'

const Data = () => {
  return (
    <div className="home__data">
        <h1 className="home__title">Gabriel Chaves</h1>
        <h3 className="home__subtitle">Software Engineer & Designer</h3>
        <p className="home__description">Creative, self-taught and dreamer.</p>
        <a href="#contact" className="button button--flex">
        Say Hi    <i class="uil uil-message button__icon"></i>
        </a>
    </div>
  )
}

export default Data